import { createPopup } from '@/assets/js/factory'
import { getCompanyPlatformBalance } from '@/api/cost-settlement/common'
import { getApprovalDetailProcess, getApprovalDetail } from '@/api/cost-settlement/myRelate'
import ApprovalDialog from './components/ApprovalDialog'
import { auditStatusApproveCode, platformStatusCode, settlementTypeCode } from './config/cost-sett'
import { getWjawardSummary, getMsgAuditSummary } from '@/api/cost-settlement/approve'
import GlobalConfig from '@/global/config'

export const auditMixins = {
  data() {
    return {
      showConfirmPay: false,
      cpDetail: {
        taskId: '',
        statementId: '',
        settleObjType: '',
        sponsor: {},
      }
    }
  },
  computed: {
    isRedPocketAudit() {
      return this.pageType && this.pageType === this.soTypeCode.PACKET
    },
    isMessageAudit() {
      return this.pageType && this.pageType === this.soTypeCode.MESSAGE
    },
    approvalDetailApi() {
      if(this.isRedPocketAudit) {
        return getWjawardSummary
      }else if(this.isMessageAudit) {
        return getMsgAuditSummary
      }else {
        return getApprovalDetailProcess
      }
    }
  },
  methods: {
    isAudit(item) {
      const arr = [
        auditStatusApproveCode.WAITAPPR,
        auditStatusApproveCode.ALREADYAPPR,
        auditStatusApproveCode.WAITPAY
      ]
      if(this.pageType && (this.pageType === this.soTypeCode.PACKET || this.pageType === this.soTypeCode.MESSAGE)) return  +item.examineStatus !== 1 || item.examineId != GlobalConfig.getDygcStaffId(); //红包审批待审批状态可以审核
      else return !(item.payStatus === null && item.currentAuditorIsMe && arr.includes(+item.auditStatus));
    },
    openApprovalDialog(item) {
      this.$set(item, 'loading', true);
      // const isRedPocketAudit = this.pageType && this.pageType === this.soTypeCode.PACKET; //红包审批
      // const requestApi = isRedPocketAudit ? getWjawardSummary : getApprovalDetailProcess
      this.approvalDetailApi(item.id).then((res) => {
        const list = res.data.data || [];
        const sponsor = (this.isRedPocketAudit || this.isMessageAudit) ? list : list[0] ?? {};
        const { planCategory, payPlatformCategory } = this.$store.getters.settlementInfo || {};
        const queryList = typeof this.queryList === 'function' ? this.queryList : () => {};
        const id = this.isRedPocketAudit ? item.awardId : ( this.isMessageAudit ? item.id : item.taskId);
        createPopup(ApprovalDialog, {
          sponsor,
          id,
          statementId: item.id,
          soType: +item.settleObjType,
          planCategory,
          payPlatformCategory,
          onApprovalSuccess: queryList.bind(this),
          pageType: this.pageType,
          approvalInfo: (this.isRedPocketAudit || this.isMessageAudit) ? list : null, 
        },{
          store: this.$store,
          router: this.$router
        });
      }).catch(() => {
        this.$message.error('获取审批流程数据失败');
      }).finally(() => {
        this.$set(item, 'loading', false);
      });
    },
    openPayDialog(item) {
      const { status } = this.$store.getters.settlementInfo || {};
      if (status === platformStatusCode.OFF) {
        this.$message.warning('支付方式未开通，请先开通后重试');
      } else {
        const settlementType = this.$store.getters.settlementType ?? -1;
        if (settlementType === settlementTypeCode.OPENSIGN) {
          this.$set(item, 'loading', true);
          Promise.all([
            getApprovalDetail(item.taskId),
            getCompanyPlatformBalance(item.id),
            getApprovalDetailProcess(item.id)
          ])
            .then(([adRes, cbRes, adpRes]) => {
              const ad = adRes?.data?.data || {}
              const sendChannels = cbRes?.data?.data?.sendChannels??[]
              const payPlatformName = cbRes?.data?.data?.payPlatformName
              console.log('cbRes:', cbRes)
              const adpList = adpRes?.data?.data ?? []
              const sponsor = adpList[0] ?? {}
              const isNotEnough = (sendChannels).find(item => ad.operationalYuanAmount > item.balanceYuanAmount)
              if (!isNotEnough) {
                const { planCategory, payPlatformCategory } = this.$store.getters.settlementInfo || {};
                const queryList = typeof this.queryList === 'function' ? this.queryList : () => {};
                // 结算小于账户余额
                createPopup(
                  ApprovalDialog,
                  {
                    pay: true,
                    approvalInfo: ad,
                    id: item.taskId,
                    statementId: item.id,
                    soType: +item.settleObjType,
                    sponsor,
                    planCategory,
                    payPlatformCategory,
                    onApprovalSuccess: queryList.bind(this),
                    sendChannels,
                    payPlatformName
                  },
                  {
                    store: this.$store,
                    router: this.$router
                  }
                )
              } else {
                // 结算大于账户余额
                this.showConfirmPay = true
                this.cpDetail.taskId = item.taskId
                this.cpDetail.statementId = item.id
                this.cpDetail.settleObjType = item.settleObjType
                this.cpDetail.sponsor = sponsor
              }
            })
            .catch(() => {
              this.$message.error('获取支付信息失败')
            })
            .finally(() => {
              this.$set(item, 'loading', false);
            })
        } else {
          this.$message.warning('支付方式未签约，请先签约后重试');
        }
      }
    },
    toAudit(item) {
      if(item.serviceRate === 4.8) {
        this.$message.warning('结算单费率已调整，无法审批')
        return
      }
      if(this.pageType && (this.pageType === this.soTypeCode.PACKET || this.pageType === this.soTypeCode.MESSAGE) && +item.examineStatus == 1) {
        this.openApprovalDialog(item);
      }
      if (auditStatusApproveCode.WAITAPPR === +item.auditStatus) {
        this.openApprovalDialog(item);
      } else if (
        auditStatusApproveCode.ALREADYAPPR === +item.auditStatus ||
        auditStatusApproveCode.WAITPAY === +item.auditStatus) {
        this.openPayDialog(item);
      }
    },
    approvalSuccessHandle() {
      const queryList = typeof this.queryList === 'function' ? this.queryList : () => {};
      this.cpDetail.taskId = '';
      this.cpDetail.statementId = '';
      this.cpDetail.settleObjType = '';
      this.cpDetail.sponsor = {};
      queryList.call(this);
    }
  }
};

export const batchSetDataMixins = {
  data() {
    return {
      investDetail: {
        settleName: 0,
        linkedSurveyProjectTotal: 0,
        investigatorsNum: 0,
        expectedYuanAmount: 0,
        serviceYuanAmount: 0,
        operationalYuanAmount: 0,
        linkedImportProject: 0,
        adjustYuanAmount: '0.00'
      },
      proxyDetail: {
        settleName: 0,
        linkedSurveyProjectTotal: 0,
        proxyNum: 0,
        operationalYuanAmount: 0,
        linkedImportProject: 0,
        adjustYuanAmount: '0.00'
      },
      allAmount: 0,
      hasInvest: false,
      hasProxy: false,
    }
  },
  methods: {
    getPrice(price) {
      return Number.isNaN(+price) ? '0.00' : (+price).toFixed(2)
    },
    getNumToFixed(num) {
      const n = Number.isNaN(+num) ? 0 : +num
      return n === 0 ? '0.00' : n < 0 ? n.toFixed(2) : `+${n.toFixed(2)}`
    },
    setDetail(detail) {
      const {
        inProjectNum,
        inLinkedProjectNum,
        inInvestigatorsNum,
        inExpectedYuanAmount,
        inServiceYuanAmount,
        inOperationalYuanAmount,
        inLinkedImportProjectNum,
        inAdjustYuanAmount,
        agentProjectNum,
        agentLinkedProjectNum,
        agentInvestigatorsNum,
        agentOperationalYuanAmount,
        agentLinkedImportProjectNum,
        allAmount
      } = detail || {};
      // 调查员
      this.investDetail.settleName = inProjectNum ?? 0;
      this.investDetail.linkedSurveyProjectTotal = inLinkedProjectNum ?? 0;
      this.investDetail.investigatorsNum = inInvestigatorsNum ?? 0;
      this.investDetail.expectedYuanAmount = inExpectedYuanAmount ?? 0;
      this.investDetail.serviceYuanAmount = inServiceYuanAmount ?? 0;
      this.investDetail.operationalYuanAmount = inOperationalYuanAmount ?? 0;
      this.investDetail.linkedImportProject = inLinkedImportProjectNum ?? 0;
      this.investDetail.adjustYuanAmount = this.getNumToFixed(inAdjustYuanAmount ?? 0);
      // 代理
      this.proxyDetail.settleName = agentProjectNum ?? 0;
      this.proxyDetail.linkedSurveyProjectTotal = agentLinkedProjectNum ?? 0;
      this.proxyDetail.proxyNum = agentInvestigatorsNum ?? 0;
      this.proxyDetail.operationalYuanAmount = agentOperationalYuanAmount ?? 0;
      this.proxyDetail.linkedImportProject = agentLinkedImportProjectNum ?? 0;
      this.proxyDetail.adjustYuanAmount = this.getNumToFixed(0);
      this.hasInvest = [
        inProjectNum,
        inLinkedProjectNum,
        inInvestigatorsNum,
        inExpectedYuanAmount,
        inServiceYuanAmount,
        inOperationalYuanAmount,
        inLinkedImportProjectNum,
        inAdjustYuanAmount
      ].some(item => item !== null);
      this.hasProxy = [
        agentProjectNum,
        agentLinkedProjectNum,
        agentInvestigatorsNum,
        agentOperationalYuanAmount,
        agentLinkedImportProjectNum,
      ].some(item => item !== null);
      // 总费用合计
      this.allAmount = (+allAmount || 0).toFixed(2);
    }
  }
}

export const initiateSettleMixins = {
  data() {
    return {
      settlePageType: 1,
      showSettle: false,
      settleDisableds: [
        'settleName',
        'settleNo',
        'settleDept',
        'settleObjType',
        'settleTimeType',
        'taskSquareUrl'
      ],
      settleInfo: {}
    }
  },
  computed: {
    settleSource() {
      const { settleName, settleNo, settleTimeType, settleDept, settleMonth, taskSquareUrl, settleCode } = this.settleInfo;
      return {
        settleName,
        settleNo,
        settleTimeType,
        settleDept,
        settleMonth,
        taskSquareUrl,
        settleCode
      }
    }
  },
  watch: {
    showSettle(bool) {
      if (!bool) {
        this.settleInfo = {}
      }
    }
  },
  methods: {
    openSettleDialog(item) {
      this.settlePageType = 1
      this.settleInfo = {
        statementId: item.id ?? '',
        settleName: item.settleName ?? '',
        settleNo: item.settleNo ?? '',
        settleTimeType: item.settleTimeType ?? 'm',
        settleDept: item.settleDept ?? '',
        settleCode: item.settleCode ?? '',
        settleMonth: item.settleMonth ?? '',
        taskSquareUrl: item.taskSquareUrl ?? ''
      }
      this.showSettle = true
    },
  }
}